export default {"src":"/_next/static/media/logo-jobready.061503c2.svg","height":300,"width":653};